import _ from 'lodash';
import { createRouter, createWebHistory } from '@ionic/vue-router';
import Matches from '../views/matches/matches.vue'
import Ladders from '../views/Ladders.vue'
import Leaderboard from '../views/Leaderboard.vue'
import Match from '../views/matches/match.vue';
import Explore from '../views/Explore.vue'
import Teams from '../views/teams/index.vue';
import TeamDetails from '../views/teams/_id.vue';
import PlayerDetails from '../views/players/_id.vue';
import StateDetails from '../views/states/_id.vue';
import AssociationDetails from '../views/associations/_id.vue';
import ClubDetails from '../views/clubs/_id.vue';
import CompDetails from '../views/competitions/_id.vue';
import Results from '../views/results/Results.vue'
import ResultDisplay from '../views/results/ResultDisplay.vue'
import Search from '../views/search.vue';
import store from '../store/index';

// import Redirect from '../views/redirect.vue';

const routes = [
  {
    path: '/results',
    name: 'results',
    component: Results,
  },
  {
    path: '/c/:entityLevel/:entityName/results',
    name: 'custom-results',
    component: Results,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/results/:id',
    name: 'result-display',
    component: ResultDisplay,
    props: true,
  },
  {
    path: '/c/:entityLevel/:entityName/results/:id',
    name: 'custom-result-display',
    component: ResultDisplay,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
  {
    path: '/explore',
    redirect: '/tabs/explore'
  },
  {
    path: '/c/:entityLevel/:entityName/explore',
    redirect: '/c/:entityLevel/:entityName/tabs/explore',
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),

  },
  {
    path: '/search',
    component: Search,
    name: 'Search',
  },
  {
    path: '/c/:entityLevel/:entityName/search',

    component: Search,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('national/setup');
      const settings = store.getters['national/presentation'];
      console.log('settings at index', settings);
      if(settings &&settings.useExplorer === true){
        console.log('redirecting to explore');
        next('/tabs/explore');
      }
      next('/tabs/schedule');
    }
  },
  {
    path: '/c/:entityLevel/:entityName',
    beforeEnter: async (to, from, next) => {
      await store.dispatch('national/setup');
      const settings = store.getters['national/presentation'];
      if(settings && settings.useExplorer === true){
        next(`/c/${to.params.entityLevel}/${to.params.entityName}/tabs/explore`);
      }else{
        next(`/c/${to.params.entityLevel}/${to.params.entityName}/tabs/schedule`);
      }

    },
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/matches',
    redirect: '/tabs/schedule'
  },
  {
    path: '/teams',
    component: Teams,
    name: 'Teams',
  },
  {
    path: '/c/:entityLevel/:entityName/teams',
    component: Teams,
    props: (route) => ({
      entityLevel: route.params.entityLevel,

      entityName: route.params.entityName,
    }),
  },
  {
    path: '/teams/:id',
    component: TeamDetails,
    name: 'TeamDetails',
  },
  {
    path: '/c/:entityLevel/:entityName/teams/:id',
    component: TeamDetails,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
  {
    path: '/states/:id',
    component: StateDetails,
    name: 'StateDetails',
  },
  {
    path: '/associations/:id',
    component: AssociationDetails,
    name: 'AssociationDetails',
  },
  {
    path: '/c/:entityLevel/:entityName/states/:id',
    component: StateDetails,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
  {
    path: '/c/:entityLevel/:entityName/associations/:id',
    component: AssociationDetails,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
  {
    path: '/c/:entityLevel/:entityName/explore',
    redirect: to => {
      console.log('Redirecting with entityLevel:', to.params.entityLevel, 'and entityName:', to.params.entityName);
      return { path: `/c/${to.params.entityLevel}/${to.params.entityName}/tabs/explore` }
    },
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/clubs/:id',
    component: ClubDetails,
    name: 'ClubDetails',
  },
  {
    path: '/c/:entityLevel/:entityName/clubs/:id',
    component: ClubDetails,
    props: (route) => ({
      entityLevel: route.params.entityLevel,

      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
  {
    path: '/competitions/:id',
    component: CompDetails,
    name: 'CompetitionDetails',
  },
  {
    path: '/c/:entityLevel/:entityName/competitions/:id',
    component: CompDetails,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
  {
    path: '/players/:id',
    component: PlayerDetails,
    name: 'PlayerDetails',
  },
  {
    path: '/c/:entityLevel/:entityName/players/:id',
    component: PlayerDetails,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
  {
    path: '/tabs/schedule',
    name: 'matches',
    component: Matches,

  },
  {
    path: '/c/:entityLevel/:entityName/tabs/schedule',
    name: 'custom-matches',
    component: Matches,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/tabs/schedule',
    name: 'ladders',
    component: Matches,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/c/:entityLevel/:entityName/tabs/ladders',
    name: 'custom-ladders',
    component: Matches,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/tabs/leaderboard',
    name: 'leaderboard',
    component: Matches,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/tabs/ladders',
    name: 'ladders',
    component: Matches,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/c/:entityLevel/:entityName/tabs/leaderboard',
    component: Matches,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/tabs/explore',
    name: 'explore',
    component: Explore,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/c/:entityLevel/:entityName/tabs/explore',
    name: 'custom-explore',
    component: Explore,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
    }),
  },
  {
    path: '/matches/:id',
    name: 'matches.detail',
    component: Match,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/c/:entityLevel/:entityName/matches/:id',
    component: Match,
    props: (route) => ({
      entityLevel: route.params.entityLevel,
      entityName: route.params.entityName,
      id: route.params.id,
    }),
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

router.beforeEach(async (to, from, next) => {
  // handle custom routes
  if (to.path.includes('c/')) {
    // Attempt to extract entityLevel and entityName from params
    let entityLevel = _.get(to, 'params.entityLevel');
    let entityName = _.get(to, 'params.entityName');
    // If params do not contain entityLevel or entityName, extract from path
    if (!entityLevel || !entityName) {
      const pathSegments = to.path.split('/');
      const cIndex = pathSegments.indexOf('c');
      if (cIndex !== -1 && pathSegments.length > cIndex + 2) {
        entityLevel = pathSegments[cIndex + 1];
        entityName = pathSegments[cIndex + 2];
      }
    }
    console.log('entityLevel', entityLevel, 'entityName', entityName);
    if (!entityLevel || !entityName) {
      store.commit('national/resetCustom', {});
    } else {
      const activeEntity = store.getters['national/getEntity'];
      console.log('activeEntity', activeEntity);
      if ((activeEntity && activeEntity.name !== entityName) || !activeEntity._id) {
        console.log('getting slug branding');
        await store.dispatch('national/getSlugBranding', { entityLevel, entityName });
      }
    }
  } else {
    store.commit('national/resetCustom', {});
  }
  next();
})


// router.beforeEach((to, from, next) => {
//   if (to.matched.some((record) => _.get(record, 'meta.requiresAuth') === true)) {
//     const now = moment().valueOf();
//     const expiry = store.getters['user/expiry'];
//     const userId = store.getters['user/userId'];
//     const isAuthenticated = store.getters['user/isAuthenticated'];
//     const refreshToken = store.getters['user/refreshToken'];
//     const verified = store.getters['user/isVerified'];
//     const roles = store.getters['user/roles'];

//     if (isAuthenticated && expiry - 300 > now) {
//       // Valid Token
//       if (!verified || roles.length <= 0) {
//         // Account not verified, redirect to verify page
//         store.commit('user/logout');
//         next('/login');
//       } else {
//         // Account Verified
//         next();
//       }
//     } else if (expiry - 300 <= now && refreshToken && userId) {
//       // Expired Token, refresh token before going to page
//       store.commit('loading', true);
//       httpNoAuth.post('/assemble/api/v1/account/live/authorize',
//         {
//           refresh_token: refreshToken,
//           user_id: userId,
//         })
//         .then((response) => {
//           // Refresh Successful - Login User
//           store.commit('user/login', response.data);
//           store.dispatch('national/setup');
//           store.dispatch('user/fetchReferee');
//           store.dispatch('user/fetchUserData');
//           next();
//         })
//         .catch(() => {
//           // Failed Refresh - Logout User
//           store.commit('user/logout');
//           next('/login');
//         });
//     } else {
//       // No Data - Redirect to Login
//       store.commit('user/logout');
//       next('/login');
//     }
//   } else {
//     next();
//   }
// });

export default router
